module.exports = __webpack_public_path__ + "static/media/corona-head.43e8d94c.png";